<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>luminoso</title>
      <path fill="#679940"
        d="M23.46,1H8.54a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1h1.7L14,29H12a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H18l3.76-5h1.7a1,1,0,0,0,1-1V2A1,1,0,0,0,23.46,1ZM16,28.34,12.74,24h6.52ZM22.46,22H9.54V3H22.46Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Luminoso"
};
</script>


// WEBPACK FOOTER //
// src/icons/LuminosoIcon.vue